import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "variant-testing",
  "use": "variant-testing-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 20\" id=\"variant-testing\"><path clip-rule=\"evenodd\" d=\"M2.376 18.295c2.411 1.693 4.2-.012 5.217-1.47l7.16-10.26 1.93-1.049L10.254 1 1.968 12.874c-1.017 1.457-2.002 3.727.408 5.42z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M12.292 9.372c-2.862-.748-4.381.686-7.244-.062\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/variant-testing.svg
// module id = iaDg
// module chunks = 39 44